/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	ComponentsBatchRequest,
	DeployRequest,
	ListPraetorComponentsParams,
	ListPraetorPolicyPlansParams,
	PolicyPlanComponentRequest,
	PolicyPlanComponentUpdateRequest,
	PolicyPlanOrderRequest,
	PraetoidError,
	Praetor,
	PraetorComponentListResponse,
	PraetorDeleteResponse,
	PraetorListResponse,
	PraetorPolicyPlanComponentListResponse,
	PraetorRequest,
	PraetorUpdateRequest,
	PraetorVersionListResponse,
	RestoreRequest
} from '../models';

/**
 * Returns all praetors for the organization
 * @summary List organization's praetors
 */
export const listPraetors = () => {
	return customInstance<PraetorListResponse>({ url: `/praetors`, method: 'GET' });
};

export const getListPraetorsQueryKey = () => {
	return ['praetors'] as const;
};

export const getListPraetorsQueryOptions = <
	TData = Awaited<ReturnType<typeof listPraetors>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPraetors>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPraetorsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPraetors>>> = () => listPraetors();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPraetors>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPraetorsQueryResult = NonNullable<Awaited<ReturnType<typeof listPraetors>>>;
export type ListPraetorsQueryError = ErrorType<PraetoidError>;

export function useListPraetors<
	TData = Awaited<ReturnType<typeof listPraetors>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPraetors>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetors>>,
					TError,
					Awaited<ReturnType<typeof listPraetors>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetors<
	TData = Awaited<ReturnType<typeof listPraetors>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPraetors>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetors>>,
					TError,
					Awaited<ReturnType<typeof listPraetors>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetors<
	TData = Awaited<ReturnType<typeof listPraetors>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPraetors>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List organization's praetors
 */

export function useListPraetors<
	TData = Awaited<ReturnType<typeof listPraetors>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPraetors>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPraetorsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new praetor for the organization
 * @summary Create a new praetor
 */
export const createPraetor = (praetorRequest: PraetorRequest) => {
	return customInstance<Praetor>({
		url: `/praetors`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: praetorRequest
	});
};

export const getCreatePraetorMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPraetor>>,
		TError,
		{ data: PraetorRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createPraetor>>,
	TError,
	{ data: PraetorRequest },
	TContext
> => {
	const mutationKey = ['createPraetor'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createPraetor>>,
		{ data: PraetorRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createPraetor(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreatePraetorMutationResult = NonNullable<Awaited<ReturnType<typeof createPraetor>>>;
export type CreatePraetorMutationBody = PraetorRequest;
export type CreatePraetorMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a new praetor
 */
export const useCreatePraetor = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createPraetor>>,
			TError,
			{ data: PraetorRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createPraetor>>,
	TError,
	{ data: PraetorRequest },
	TContext
> => {
	return useMutation(getCreatePraetorMutationOptions(options), queryClient);
};
/**
 * Deletes a praetor
 * @summary Delete a praetor
 */
export const deletePraetor = (id: string) => {
	return customInstance<PraetorDeleteResponse>({ url: `/praetors/${id}`, method: 'DELETE' });
};

export const getDeletePraetorMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deletePraetor>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deletePraetor>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['deletePraetor'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePraetor>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return deletePraetor(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeletePraetorMutationResult = NonNullable<Awaited<ReturnType<typeof deletePraetor>>>;

export type DeletePraetorMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete a praetor
 */
export const useDeletePraetor = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deletePraetor>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deletePraetor>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDeletePraetorMutationOptions(options), queryClient);
};
/**
 * Returns the details of a specific praetor
 * @summary Get praetor details
 */
export const getPraetor = (id: string) => {
	return customInstance<Praetor>({ url: `/praetors/${id}`, method: 'GET' });
};

export const getGetPraetorQueryKey = (id: string) => {
	return ['praetors', id] as const;
};

export const getGetPraetorQueryOptions = <
	TData = Awaited<ReturnType<typeof getPraetor>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPraetor>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPraetorQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPraetor>>> = () => getPraetor(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPraetor>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPraetorQueryResult = NonNullable<Awaited<ReturnType<typeof getPraetor>>>;
export type GetPraetorQueryError = ErrorType<PraetoidError>;

export function useGetPraetor<
	TData = Awaited<ReturnType<typeof getPraetor>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPraetor>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getPraetor>>,
					TError,
					Awaited<ReturnType<typeof getPraetor>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPraetor<
	TData = Awaited<ReturnType<typeof getPraetor>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPraetor>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getPraetor>>,
					TError,
					Awaited<ReturnType<typeof getPraetor>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPraetor<
	TData = Awaited<ReturnType<typeof getPraetor>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPraetor>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get praetor details
 */

export function useGetPraetor<
	TData = Awaited<ReturnType<typeof getPraetor>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPraetor>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetPraetorQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates praetor fields and/or live version pointer
 * @summary Update praetor
 */
export const updatePraetor = (id: string, praetorUpdateRequest: PraetorUpdateRequest) => {
	return customInstance<Praetor>({
		url: `/praetors/${id}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: praetorUpdateRequest
	});
};

export const getUpdatePraetorMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePraetor>>,
		TError,
		{ id: string; data: PraetorUpdateRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePraetor>>,
	TError,
	{ id: string; data: PraetorUpdateRequest },
	TContext
> => {
	const mutationKey = ['updatePraetor'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePraetor>>,
		{ id: string; data: PraetorUpdateRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePraetor(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePraetorMutationResult = NonNullable<Awaited<ReturnType<typeof updatePraetor>>>;
export type UpdatePraetorMutationBody = PraetorUpdateRequest;
export type UpdatePraetorMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update praetor
 */
export const useUpdatePraetor = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePraetor>>,
			TError,
			{ id: string; data: PraetorUpdateRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePraetor>>,
	TError,
	{ id: string; data: PraetorUpdateRequest },
	TContext
> => {
	return useMutation(getUpdatePraetorMutationOptions(options), queryClient);
};
/**
 * Promotes the current draft (latest version) to live
 * @summary Deploy praetor draft
 */
export const deployPraetor = (id: string, deployRequest: DeployRequest) => {
	return customInstance<Praetor>({
		url: `/praetors/${id}/deploy`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: deployRequest
	});
};

export const getDeployPraetorMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deployPraetor>>,
		TError,
		{ id: string; data: DeployRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deployPraetor>>,
	TError,
	{ id: string; data: DeployRequest },
	TContext
> => {
	const mutationKey = ['deployPraetor'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deployPraetor>>,
		{ id: string; data: DeployRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return deployPraetor(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeployPraetorMutationResult = NonNullable<Awaited<ReturnType<typeof deployPraetor>>>;
export type DeployPraetorMutationBody = DeployRequest;
export type DeployPraetorMutationError = ErrorType<PraetoidError>;

/**
 * @summary Deploy praetor draft
 */
export const useDeployPraetor = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deployPraetor>>,
			TError,
			{ id: string; data: DeployRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deployPraetor>>,
	TError,
	{ id: string; data: DeployRequest },
	TContext
> => {
	return useMutation(getDeployPraetorMutationOptions(options), queryClient);
};
/**
 * Discards the current draft, reverting to the live version
 * @summary Discard praetor draft
 */
export const discardPraetorDraft = (id: string) => {
	return customInstance<Praetor>({ url: `/praetors/${id}/draft/discard`, method: 'POST' });
};

export const getDiscardPraetorDraftMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof discardPraetorDraft>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof discardPraetorDraft>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['discardPraetorDraft'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof discardPraetorDraft>>,
		{ id: string }
	> = (props) => {
		const { id } = props ?? {};

		return discardPraetorDraft(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DiscardPraetorDraftMutationResult = NonNullable<
	Awaited<ReturnType<typeof discardPraetorDraft>>
>;

export type DiscardPraetorDraftMutationError = ErrorType<PraetoidError>;

/**
 * @summary Discard praetor draft
 */
export const useDiscardPraetorDraft = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof discardPraetorDraft>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof discardPraetorDraft>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDiscardPraetorDraftMutationOptions(options), queryClient);
};
/**
 * Hard resets both live and latest pointers to a historical version
 * @summary Restore a praetor version
 */
export const restorePraetorVersion = (id: string, restoreRequest: RestoreRequest) => {
	return customInstance<Praetor>({
		url: `/praetors/${id}/restore`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: restoreRequest
	});
};

export const getRestorePraetorVersionMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof restorePraetorVersion>>,
		TError,
		{ id: string; data: RestoreRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof restorePraetorVersion>>,
	TError,
	{ id: string; data: RestoreRequest },
	TContext
> => {
	const mutationKey = ['restorePraetorVersion'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof restorePraetorVersion>>,
		{ id: string; data: RestoreRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return restorePraetorVersion(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type RestorePraetorVersionMutationResult = NonNullable<
	Awaited<ReturnType<typeof restorePraetorVersion>>
>;
export type RestorePraetorVersionMutationBody = RestoreRequest;
export type RestorePraetorVersionMutationError = ErrorType<PraetoidError>;

/**
 * @summary Restore a praetor version
 */
export const useRestorePraetorVersion = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof restorePraetorVersion>>,
			TError,
			{ id: string; data: RestoreRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof restorePraetorVersion>>,
	TError,
	{ id: string; data: RestoreRequest },
	TContext
> => {
	return useMutation(getRestorePraetorVersionMutationOptions(options), queryClient);
};
/**
 * Returns all versions for a praetor
 * @summary List praetor versions
 */
export const listPraetorVersions = (id: string) => {
	return customInstance<PraetorVersionListResponse>({
		url: `/praetors/${id}/versions`,
		method: 'GET'
	});
};

export const getListPraetorVersionsQueryKey = (id: string) => {
	return ['praetors', id, 'versions'] as const;
};

export const getListPraetorVersionsQueryOptions = <
	TData = Awaited<ReturnType<typeof listPraetorVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorVersions>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPraetorVersionsQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPraetorVersions>>> = () =>
		listPraetorVersions(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPraetorVersions>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPraetorVersionsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPraetorVersions>>
>;
export type ListPraetorVersionsQueryError = ErrorType<PraetoidError>;

export function useListPraetorVersions<
	TData = Awaited<ReturnType<typeof listPraetorVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorVersions>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorVersions>>,
					TError,
					Awaited<ReturnType<typeof listPraetorVersions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorVersions<
	TData = Awaited<ReturnType<typeof listPraetorVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorVersions>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorVersions>>,
					TError,
					Awaited<ReturnType<typeof listPraetorVersions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorVersions<
	TData = Awaited<ReturnType<typeof listPraetorVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorVersions>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List praetor versions
 */

export function useListPraetorVersions<
	TData = Awaited<ReturnType<typeof listPraetorVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorVersions>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPraetorVersionsQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Lists all components for a praetor version reference
 * @summary List praetor components
 */
export const listPraetorComponents = (praetorId: string, params?: ListPraetorComponentsParams) => {
	return customInstance<PraetorComponentListResponse>({
		url: `/praetors/${praetorId}/components`,
		method: 'GET',
		params
	});
};

export const getListPraetorComponentsQueryKey = (
	praetorId: string,
	params?: ListPraetorComponentsParams
) => {
	return ['praetors', praetorId, 'components', ...(params ? [params] : [])] as const;
};

export const getListPraetorComponentsQueryOptions = <
	TData = Awaited<ReturnType<typeof listPraetorComponents>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorComponents>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPraetorComponentsQueryKey(praetorId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPraetorComponents>>> = () =>
		listPraetorComponents(praetorId, params);

	return { queryKey, queryFn, enabled: !!praetorId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPraetorComponents>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPraetorComponentsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPraetorComponents>>
>;
export type ListPraetorComponentsQueryError = ErrorType<PraetoidError>;

export function useListPraetorComponents<
	TData = Awaited<ReturnType<typeof listPraetorComponents>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: undefined | ListPraetorComponentsParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorComponents>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorComponents>>,
					TError,
					Awaited<ReturnType<typeof listPraetorComponents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorComponents<
	TData = Awaited<ReturnType<typeof listPraetorComponents>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorComponents>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorComponents>>,
					TError,
					Awaited<ReturnType<typeof listPraetorComponents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorComponents<
	TData = Awaited<ReturnType<typeof listPraetorComponents>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorComponents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List praetor components
 */

export function useListPraetorComponents<
	TData = Awaited<ReturnType<typeof listPraetorComponents>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorComponents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPraetorComponentsQueryOptions(praetorId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Applies multiple component operations in a single copy-on-write version
 * @summary Batch component mutations
 */
export const batchPraetorComponents = (
	praetorId: string,
	componentsBatchRequest: ComponentsBatchRequest
) => {
	return customInstance<Praetor>({
		url: `/praetors/${praetorId}/components/batch`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: componentsBatchRequest
	});
};

export const getBatchPraetorComponentsMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof batchPraetorComponents>>,
		TError,
		{ praetorId: string; data: ComponentsBatchRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof batchPraetorComponents>>,
	TError,
	{ praetorId: string; data: ComponentsBatchRequest },
	TContext
> => {
	const mutationKey = ['batchPraetorComponents'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof batchPraetorComponents>>,
		{ praetorId: string; data: ComponentsBatchRequest }
	> = (props) => {
		const { praetorId, data } = props ?? {};

		return batchPraetorComponents(praetorId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type BatchPraetorComponentsMutationResult = NonNullable<
	Awaited<ReturnType<typeof batchPraetorComponents>>
>;
export type BatchPraetorComponentsMutationBody = ComponentsBatchRequest;
export type BatchPraetorComponentsMutationError = ErrorType<PraetoidError>;

/**
 * @summary Batch component mutations
 */
export const useBatchPraetorComponents = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof batchPraetorComponents>>,
			TError,
			{ praetorId: string; data: ComponentsBatchRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof batchPraetorComponents>>,
	TError,
	{ praetorId: string; data: ComponentsBatchRequest },
	TContext
> => {
	return useMutation(getBatchPraetorComponentsMutationOptions(options), queryClient);
};
/**
 * Lists policy plan components with joined policy plan and version metadata
 * @summary List praetor policy plan components
 */
export const listPraetorPolicyPlans = (
	praetorId: string,
	params?: ListPraetorPolicyPlansParams
) => {
	return customInstance<PraetorPolicyPlanComponentListResponse>({
		url: `/praetors/${praetorId}/policy-plans`,
		method: 'GET',
		params
	});
};

export const getListPraetorPolicyPlansQueryKey = (
	praetorId: string,
	params?: ListPraetorPolicyPlansParams
) => {
	return ['praetors', praetorId, 'policy-plans', ...(params ? [params] : [])] as const;
};

export const getListPraetorPolicyPlansQueryOptions = <
	TData = Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorPolicyPlansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorPolicyPlans>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPraetorPolicyPlansQueryKey(praetorId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPraetorPolicyPlans>>> = () =>
		listPraetorPolicyPlans(praetorId, params);

	return { queryKey, queryFn, enabled: !!praetorId, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPraetorPolicyPlansQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPraetorPolicyPlans>>
>;
export type ListPraetorPolicyPlansQueryError = ErrorType<PraetoidError>;

export function useListPraetorPolicyPlans<
	TData = Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params: undefined | ListPraetorPolicyPlansParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorPolicyPlans>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
					TError,
					Awaited<ReturnType<typeof listPraetorPolicyPlans>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorPolicyPlans<
	TData = Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorPolicyPlansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorPolicyPlans>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
					TError,
					Awaited<ReturnType<typeof listPraetorPolicyPlans>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPraetorPolicyPlans<
	TData = Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorPolicyPlansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorPolicyPlans>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List praetor policy plan components
 */

export function useListPraetorPolicyPlans<
	TData = Awaited<ReturnType<typeof listPraetorPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	praetorId: string,
	params?: ListPraetorPolicyPlansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPraetorPolicyPlans>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPraetorPolicyPlansQueryOptions(praetorId, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Adds a policy plan component via copy-on-write
 * @summary Add policy plan component
 */
export const addPraetorPolicyPlan = (
	praetorId: string,
	policyPlanComponentRequest: PolicyPlanComponentRequest
) => {
	return customInstance<Praetor>({
		url: `/praetors/${praetorId}/policy-plans`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: policyPlanComponentRequest
	});
};

export const getAddPraetorPolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof addPraetorPolicyPlan>>,
		TError,
		{ praetorId: string; data: PolicyPlanComponentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof addPraetorPolicyPlan>>,
	TError,
	{ praetorId: string; data: PolicyPlanComponentRequest },
	TContext
> => {
	const mutationKey = ['addPraetorPolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof addPraetorPolicyPlan>>,
		{ praetorId: string; data: PolicyPlanComponentRequest }
	> = (props) => {
		const { praetorId, data } = props ?? {};

		return addPraetorPolicyPlan(praetorId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AddPraetorPolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof addPraetorPolicyPlan>>
>;
export type AddPraetorPolicyPlanMutationBody = PolicyPlanComponentRequest;
export type AddPraetorPolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Add policy plan component
 */
export const useAddPraetorPolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof addPraetorPolicyPlan>>,
			TError,
			{ praetorId: string; data: PolicyPlanComponentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof addPraetorPolicyPlan>>,
	TError,
	{ praetorId: string; data: PolicyPlanComponentRequest },
	TContext
> => {
	return useMutation(getAddPraetorPolicyPlanMutationOptions(options), queryClient);
};
/**
 * Reorders policy plans via copy-on-write
 * @summary Reorder policy plan components
 */
export const reorderPraetorPolicyPlans = (
	praetorId: string,
	policyPlanOrderRequest: PolicyPlanOrderRequest
) => {
	return customInstance<Praetor>({
		url: `/praetors/${praetorId}/policy-plans/order`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: policyPlanOrderRequest
	});
};

export const getReorderPraetorPolicyPlansMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>,
		TError,
		{ praetorId: string; data: PolicyPlanOrderRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>,
	TError,
	{ praetorId: string; data: PolicyPlanOrderRequest },
	TContext
> => {
	const mutationKey = ['reorderPraetorPolicyPlans'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>,
		{ praetorId: string; data: PolicyPlanOrderRequest }
	> = (props) => {
		const { praetorId, data } = props ?? {};

		return reorderPraetorPolicyPlans(praetorId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderPraetorPolicyPlansMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>
>;
export type ReorderPraetorPolicyPlansMutationBody = PolicyPlanOrderRequest;
export type ReorderPraetorPolicyPlansMutationError = ErrorType<PraetoidError>;

/**
 * @summary Reorder policy plan components
 */
export const useReorderPraetorPolicyPlans = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>,
			TError,
			{ praetorId: string; data: PolicyPlanOrderRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof reorderPraetorPolicyPlans>>,
	TError,
	{ praetorId: string; data: PolicyPlanOrderRequest },
	TContext
> => {
	return useMutation(getReorderPraetorPolicyPlansMutationOptions(options), queryClient);
};
/**
 * Removes a policy plan component via copy-on-write
 * @summary Remove policy plan component
 */
export const removePraetorPolicyPlan = (praetorId: string, policyPlanId: string) => {
	return customInstance<Praetor>({
		url: `/praetors/${praetorId}/policy-plans/${policyPlanId}`,
		method: 'DELETE'
	});
};

export const getRemovePraetorPolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof removePraetorPolicyPlan>>,
		TError,
		{ praetorId: string; policyPlanId: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof removePraetorPolicyPlan>>,
	TError,
	{ praetorId: string; policyPlanId: string },
	TContext
> => {
	const mutationKey = ['removePraetorPolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof removePraetorPolicyPlan>>,
		{ praetorId: string; policyPlanId: string }
	> = (props) => {
		const { praetorId, policyPlanId } = props ?? {};

		return removePraetorPolicyPlan(praetorId, policyPlanId);
	};

	return { mutationFn, ...mutationOptions };
};

export type RemovePraetorPolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof removePraetorPolicyPlan>>
>;

export type RemovePraetorPolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Remove policy plan component
 */
export const useRemovePraetorPolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof removePraetorPolicyPlan>>,
			TError,
			{ praetorId: string; policyPlanId: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof removePraetorPolicyPlan>>,
	TError,
	{ praetorId: string; policyPlanId: string },
	TContext
> => {
	return useMutation(getRemovePraetorPolicyPlanMutationOptions(options), queryClient);
};
/**
 * Updates a policy plan component via copy-on-write
 * @summary Update policy plan component
 */
export const updatePraetorPolicyPlan = (
	praetorId: string,
	policyPlanId: string,
	policyPlanComponentUpdateRequest: PolicyPlanComponentUpdateRequest
) => {
	return customInstance<Praetor>({
		url: `/praetors/${praetorId}/policy-plans/${policyPlanId}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: policyPlanComponentUpdateRequest
	});
};

export const getUpdatePraetorPolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePraetorPolicyPlan>>,
		TError,
		{ praetorId: string; policyPlanId: string; data: PolicyPlanComponentUpdateRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePraetorPolicyPlan>>,
	TError,
	{ praetorId: string; policyPlanId: string; data: PolicyPlanComponentUpdateRequest },
	TContext
> => {
	const mutationKey = ['updatePraetorPolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePraetorPolicyPlan>>,
		{ praetorId: string; policyPlanId: string; data: PolicyPlanComponentUpdateRequest }
	> = (props) => {
		const { praetorId, policyPlanId, data } = props ?? {};

		return updatePraetorPolicyPlan(praetorId, policyPlanId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePraetorPolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePraetorPolicyPlan>>
>;
export type UpdatePraetorPolicyPlanMutationBody = PolicyPlanComponentUpdateRequest;
export type UpdatePraetorPolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update policy plan component
 */
export const useUpdatePraetorPolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePraetorPolicyPlan>>,
			TError,
			{ praetorId: string; policyPlanId: string; data: PolicyPlanComponentUpdateRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePraetorPolicyPlan>>,
	TError,
	{ praetorId: string; policyPlanId: string; data: PolicyPlanComponentUpdateRequest },
	TContext
> => {
	return useMutation(getUpdatePraetorPolicyPlanMutationOptions(options), queryClient);
};
